import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { COUNTRIES, listCurrencies } from "@/js/lists.ts";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formatPrice, getSymbolCurrency, roundToTwoDigit } from "@/js/currency/currencies.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import WineNaming from "@/components/products/WineNaming.vue";
export default {
  name: "ScheduledWineConditionalDiscountsModal",
  props: {
    wine: {
      type: Object,
      default: {}
    },
    listThresholds: {
      type: Array,
      default: []
    },
    derivedUserGroups: {
      type: Array,
      default: []
    },
    gettingCountriesResults: {
      type: Object,
      default: {}
    }
  },
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    WineNaming: WineNaming
  },
  data: function data(_this) {
    return {
      shown: false,
      isLoading: false,
      isAdding: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      openedPanels: [0],
      now: new Date(),
      minDate: moment().add(1, "days").toDate().formatForDatePickerDays(),
      form: {
        futurePriceCurrencyIncludeDefaultShipping: null,
        scheduledApplicationDate: moment().add(1, "months").startOf("month").toDate().formatForDatePickerDays(),
        bottleThreshold: null,
        countryId: COUNTRIES.USA.id,
        futureCurrency: "USD",
        stateId: null,
        userGroup: "HORECA"
      },
      addDateMenu: null,
      listDefaultCurrencies: [],
      scheduledModifications: [],
      futureHeaders: [{
        text: "Scheduled date",
        value: "scheduledApplicationDate",
        align: "left"
      }, {
        text: "Min qty (btls)",
        value: "bottleThreshold",
        align: "left"
      }, {
        text: "Country",
        value: "country",
        align: "left"
      }, {
        text: "Group",
        value: "userGroup",
        align: "left"
      }, {
        text: "Future price",
        value: "futurePrice",
        align: "left"
      }, {
        text: "",
        value: "action",
        align: "right"
      }],
      previousHeaders: [{
        text: "Application date",
        value: "actualApplicationDate",
        align: "left"
      }, {
        text: "Min qty (btls)",
        value: "bottleThreshold",
        align: "left"
      }, {
        text: "Country",
        value: "country",
        align: "left"
      }, {
        text: "Group",
        value: "userGroup",
        align: "left"
      }, {
        text: "Price modification",
        value: "priceModification",
        align: "left"
      }],
      gettingUserIdExemple: {
        isPending: false,
        cancellationToken: null,
        showWarningMessageUserExemple: false
      },
      gettingCurrentPrice: {
        isPending: false,
        cancellationToken: null,
        result: null
      },
      managedExceptions: {
        warning: {
          conflict_date: "This wine has already a scheduled discount for this configuration."
        }
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isAdding || this.isDeleting;
    },
    isInvalidForm: function isInvalidForm() {
      return !this.form.isValid || this.form.scheduledApplicationDate <= this.now;
    },
    futureScheduledModifications: function futureScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return !x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(a.scheduledApplicationDate) - new Date(b.scheduledApplicationDate);
      });
    },
    previousScheduledModifications: function previousScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(b.scheduledApplicationDate) - new Date(a.scheduledApplicationDate);
      });
    },
    countryChosenStates: function countryChosenStates() {
      var _this$gettingCountrie,
        _this$gettingCountrie2,
        _this2 = this;
      if (this.form.countryId > 0) return (_this$gettingCountrie = (_this$gettingCountrie2 = this.gettingCountriesResults.states) === null || _this$gettingCountrie2 === void 0 ? void 0 : _this$gettingCountrie2.filter(function (x) {
        return x.id_country === _this2.form.countryId;
      })) !== null && _this$gettingCountrie !== void 0 ? _this$gettingCountrie : [];
    },
    addingDiscountCanFetchCurrentPrice: function addingDiscountCanFetchCurrentPrice() {
      var _this$form$userGroup;
      return this.form.countryId > 0 && ((_this$form$userGroup = this.form.userGroup) === null || _this$form$userGroup === void 0 ? void 0 : _this$form$userGroup.length) > 0;
    },
    addingDiscountPriceRules: function addingDiscountPriceRules() {
      var _this$gettingCurrentP;
      var rules = [this.formRules.mustBeGreaterThan0];
      if ((_this$gettingCurrentP = this.gettingCurrentPrice) !== null && _this$gettingCurrentP !== void 0 && _this$gettingCurrentP.result) {
        rules.push(this.formRules.mustBeLowerThan(this.gettingCurrentPrice.result.customerPriceIncludeDefaultShippingCurrency));
      }
      return rules;
    },
    addingDiscountGrossMargin: function addingDiscountGrossMargin() {
      var _this$gettingCurrentP2;
      if ((_this$gettingCurrentP2 = this.gettingCurrentPrice) !== null && _this$gettingCurrentP2 !== void 0 && _this$gettingCurrentP2.result && this.form.futurePriceCurrencyIncludeDefaultShipping > 0) {
        var defaultShippingCurrency = this.gettingCurrentPrice.result.defaultShippingPerBottleCurrency;
        var revenueCurrency = this.form.futurePriceCurrencyIncludeDefaultShipping - defaultShippingCurrency;
        var cogsCurrency = this.wine.cogs_euro_ex_vat * this.gettingCurrentPrice.result.currencyRate;
        if (revenueCurrency <= 0) {
          return "Too low to be calculated";
        }
        return roundToTwoDigit((revenueCurrency - cogsCurrency) / revenueCurrency * 100);
      } else {
        return "?";
      }
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this3.changeCountry();
            _context.next = 3;
            return _this3.getScheduledModifications();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    getScheduledModifications: function getScheduledModifications() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isLoading = true;
              _this = _this4;
              _context2.next = 4;
              return request("/v1/scheduled-wine-conditional-discounts/wine/".concat(_this4.wine.id_wine), "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load scheduled modifications.", {
                  type: "error"
                });
                _this4.isLoading = false;
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this4.scheduledModifications = _toConsumableArray(response.data.value);
              _this4.isLoading = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.isAdding = true;
              data = _objectSpread({}, _this5.form);
              data.wineId = _this5.wine.id_wine;
              delete data.isValid;
              _this = _this5;
              _context3.next = 7;
              return request("/v1/scheduled-wine-conditional-discounts", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to add a scheduled modification.", true);
                _this.isAdding = false;
                handleErrorData(_this, errorData);
                throw e;
              });
            case 7:
              _context3.next = 9;
              return _this5.getScheduledModifications();
            case 9:
              _this5.isAdding = false;
              _this5.$toasted.show("Scheduled modification added.", {
                type: "success"
              });
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    cancelScheduledModification: function cancelScheduledModification(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.$refs.confirm.open("Delete", "Are you sure you want to cancel this scheduled modification ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(confirm) {
                  var _this;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!confirm) {
                          _context4.next = 7;
                          break;
                        }
                        _this = _this6;
                        item.isDeleting = true;
                        _context4.next = 5;
                        return request("/v1/scheduled-wine-conditional-discounts/" + item.id, "delete", null, true, "api").catch(function (e) {
                          item.isDeleting = false;
                          var errorData = getErrorData(e, _this.managedExceptions, "Unable to cancel scheduled modification.");
                          _this.$toasted.show(errorData.message, {
                            type: errorData.type
                          });
                          throw e;
                        });
                      case 5:
                        _this6.getScheduledModifications();
                        _this6.$toasted.show("Scheduled modification cancelled.", {
                          type: "success"
                        });
                      case 7:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    changeCountry: function changeCountry() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.form.stateId = null;
              _this7.verifyCurrencies();
              _this7.$nextTick(function () {
                _this7.getCurrentPrice();
              });
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    changeState: function changeState() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.$nextTick(function () {
                _this8.getCurrentPrice();
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    changeUserGroup: function changeUserGroup() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.$nextTick(function () {
                _this9.getCurrentPrice();
              });
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    changeCurrency: function changeCurrency() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.$nextTick(function () {
                _this10.getCurrentPrice();
              });
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getCurrentPrice: function getCurrentPrice() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var userId, _this11$gettingCurren, data, _this, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.gettingCurrentPrice.result = null;
              _context10.next = 3;
              return _this11.getUserIdExemple();
            case 3:
              userId = _context10.sent;
              if (!(userId > 0)) {
                _context10.next = 15;
                break;
              }
              _this11.gettingCurrentPrice.isPending = true;
              (_this11$gettingCurren = _this11.gettingCurrentPrice.cancellationToken) === null || _this11$gettingCurren === void 0 || _this11$gettingCurren.cancel();
              _this11.gettingCurrentPrice.cancellationToken = axios.CancelToken.source();
              data = {
                id_wines: [_this11.wine.id_wine],
                userIdTarget: userId,
                isApplyActivePricePostingByDefault: false,
                calculatePrices: true,
                bypassStockSeek: true
              };
              _this = _this11;
              _context10.next = 12;
              return request("/v1/wines", "POST", data, true, "api", null, _this.gettingCurrentPrice.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get current price", true);
                  handleErrorData(_this, errorData);
                }
                _this.gettingCurrentPrice.isPending = false;
                throw e;
              });
            case 12:
              response = _context10.sent;
              _this11.gettingCurrentPrice.result = _objectSpread({}, response.data.wines[0]);
              _this11.gettingCurrentPrice.isPending = false;
            case 15:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    getUserIdExemple: function getUserIdExemple() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this12$gettingUserId, data, paramsQuery, _this, response, userIdExemple;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (_this12.addingDiscountCanFetchCurrentPrice) {
                _context11.next = 4;
                break;
              }
              return _context11.abrupt("return", 0);
            case 4:
              _this12.gettingUserIdExemple.isPending = true;
              (_this12$gettingUserId = _this12.gettingUserIdExemple.cancellationToken) === null || _this12$gettingUserId === void 0 || _this12$gettingUserId.cancel();
              _this12.gettingUserIdExemple.cancellationToken = axios.CancelToken.source();
              data = {
                userGroup: _this12.form.userGroup,
                countryId: _this12.form.countryId
              };
              if (_this12.form.stateId > 0) {
                data.stateId = _this12.form.stateId;
              }
              paramsQuery = Object.encodeToUri(data);
              _this = _this12;
              _context11.next = 13;
              return request("/v1/users/exemple?params=".concat(paramsQuery), "GET", data, true, "api", null, _this.gettingUserIdExemple.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get user exemple", true);
                  handleErrorData(_this, errorData);
                }
                _this.gettingUserIdExemple.isPending = false;
                throw e;
              });
            case 13:
              response = _context11.sent;
              userIdExemple = +response.data.value;
              _this12.gettingUserIdExemple.showWarningMessageUserExemple = userIdExemple <= 0;
              return _context11.abrupt("return", +response.data.value);
            case 17:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    verifyCurrencies: function verifyCurrencies() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this13$listDefaultCu;
        var availableCurrencies, _this13$user, country;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              availableCurrencies = [];
              if (_this13.form.countryId > 0) {
                if (_this13.form.countryId === COUNTRIES.USA.id) {
                  availableCurrencies = ["USD"];
                } else if (((_this13$user = _this13.user) === null || _this13$user === void 0 || (_this13$user = _this13$user.delivery_address) === null || _this13$user === void 0 || (_this13$user = _this13$user.country) === null || _this13$user === void 0 ? void 0 : _this13$user.id_country) === COUNTRIES.BAHAMAS.id) {
                  availableCurrencies = ["BSD", "USD"];
                } else {
                  country = _this13.gettingCountriesResults.countries.find(function (x) {
                    return x.id_country === _this13.form.countryId;
                  });
                  availableCurrencies.push(country.currency);
                  if (country.currency != "EUR") {
                    availableCurrencies.push("EUR");
                  }
                }
              }
              _this13.listDefaultCurrencies = listCurrencies.filter(function (x) {
                return availableCurrencies.includes(x.id);
              });
              if (!availableCurrencies.includes(_this13.form.futureCurrency)) {
                _this13.form.futureCurrency = null;
              }
              if (!_this13.form.futureCurrency && ((_this13$listDefaultCu = _this13.listDefaultCurrencies) === null || _this13$listDefaultCu === void 0 ? void 0 : _this13$listDefaultCu.length) > 0) {
                if (_this13.form.countryId === COUNTRIES.BRAZIL.id && availableCurrencies.includes("EUR")) {
                  _this13.form.futureCurrency = "EUR";
                } else {
                  _this13.form.futureCurrency = availableCurrencies[0];
                }
              }
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    filterDecimal2digitsKey: filterDecimal2digitsKey
  }
};